import { useMutation, useQueryClient } from 'react-query';

import { NOT_FOUND_ERROR_CODE } from 'app/api/errors';
import { deleteOrderDocument } from 'app/api/orders/service';
import { AxiosError } from 'axios';
import { notificationObserver } from 'utils/observer';
import { DOCUMENT_NOT_FOUND_ERROR } from '../constants';

interface UpdateDocumentMutationI {
  id: number;
  folderId: number;
  setDocumentAsUpdated: () => void;
  onSuccessAction?: () => void;
}

export const useDeleteDocumentMutation = ({
  id,
  folderId,
  setDocumentAsUpdated,
  onSuccessAction,
}: UpdateDocumentMutationI) => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(() => deleteOrderDocument(id), {
    onSuccess: () => {
      setDocumentAsUpdated();
      onSuccessAction?.();
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      queryClient.invalidateQueries({ queryKey: ['order-documents', folderId] });
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      queryClient.invalidateQueries({ queryKey: ['folder-details'] });
    },
    onError: (error: AxiosError) => {
      if (error.response?.status === NOT_FOUND_ERROR_CODE) {
        notificationObserver.publish({
          type: 'error',
          title: DOCUMENT_NOT_FOUND_ERROR,
        });
      }
    },
  });

  return { mutate, isLoading };
};
